import './ActionButton.scss'
import React, { CSSProperties, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { CustomDropdownItem } from '../Dropdown/CustomDropdownItem'

export interface ActionButtonProps {
  children?: React.ReactNode
}

export const ActionButton: React.FC<ActionButtonProps> = ({ children }) => {
  return (
    <Dropdown drop='up'>
      <Dropdown.Toggle as={ActionButtonToggle}>
        <i className='bi bi-three-dots-vertical' />
      </Dropdown.Toggle>

      <Dropdown.Menu as={ActionButtonMenu} flip={false}>
        {children}
      </Dropdown.Menu>
    </Dropdown>
  )
}

const ActionButtonToggle = React.forwardRef<
  HTMLDivElement,
  {
    onClick: (e: React.MouseEvent<HTMLDivElement>) => void
    children: React.ReactNode
  }
>(({ children, onClick }, ref) => (
  <div
    role='button'
    ref={ref}
    onClick={(e) => {
      e.preventDefault()
      onClick(e)
    }}
    className='action-button-toggle'
  >
    {children}
  </div>
))

const ActionButtonMenu = React.forwardRef<
  HTMLDivElement,
  {
    children?: React.ReactNode
    style?: CSSProperties
    className?: string
    'aria-labelledby'?: string
  }
>(({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
  const [value, setValue] = useState('')

  return (
    <div
      ref={ref}
      style={style}
      className={`${className ? className : ''} p-2 action-button-menu zocks__custom-menu__text_color`}
      aria-labelledby={labeledBy}
      dir='ltr'
    >
      <ul className='list-unstyled d-flex flex-column gap-1 m-0'>
        {React.Children.toArray(children).filter((child: any) => !value || child.props.children.toLowerCase().startsWith(value))}
      </ul>
    </div>
  )
})
